type JSONValue = string | number | boolean | null | JSONObject | JSONArray;
type JSONObject = { [key: string]: JSONValue };
type JSONArray = JSONValue[];

class PersonalInfoMasker {
  maskPersonalInfo(obj: Record<string, any>, keysToMask: RegExp[] = []): Record<string, any> {
    if (typeof obj === 'object' && obj !== null) {
      if (Array.isArray(obj)) {
        return obj.map((item) => this.maskPersonalInfo(item, keysToMask));
      }
      const maskedObj: JSONObject = {};
      for (const [key, value] of Object.entries(obj)) {
        if (typeof value === 'string' && this.isEmail(value)) {
          maskedObj[key] = this.maskEmail(value);
        } else if (this.hasSensitiveKeys(keysToMask, key) && typeof value === 'string') {
          maskedObj[key] = '********';
        } else {
          maskedObj[key] = this.maskPersonalInfo(value, keysToMask);
        }
      }
      return maskedObj;
    }
    return obj;
  }

  private hasSensitiveKeys(keysToMask: RegExp[], key: string): boolean {
    return keysToMask.some((regex) => regex.test(key));
  }

  private maskEmail(email: string): string {
    const [localPart, domainPart] = email.split('@');
    const maskedLocalPart = this.maskString(localPart);
    return `${maskedLocalPart}@${domainPart}`;
  }

  private maskString(value: string): string {
    const length = value.length;
    const maskedCharacters = '********';
    if (length <= 2) {
      return value[0] + maskedCharacters.slice(0, length - 1);
    }
    const firstCharacter = value[0];
    const lastCharacter = value[length - 1];
    const maskedPart = maskedCharacters.slice(0, length - 2);
    return firstCharacter + maskedPart + lastCharacter;
  }

  private isEmail(value: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }
}

export default PersonalInfoMasker;